import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Gallery from './Gallery';
import Reveal from '../Reveal';
import ClayIcon from '../site/ClayIcon';

const SERVICES = [
  { key: 'airport', icon: 'plane' },
  { key: 'city', icon: 'car' },
  { key: 'hourly', icon: 'clock' },
];

function WhereWeDrive() {
  const { t } = useTranslation();

  return (
    <section id="services" className="bg-mist py-12 font-sans lg:py-16">
      <div className="site-container grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
        <div>
          <h2 className="m-0 text-[28px] font-bold leading-tight tracking-tight text-navy lg:text-[44px]">
            {t('home.servicesPreview.title')}
          </h2>
          <ul className="m-0 mt-6 list-none space-y-4 p-0">
            {SERVICES.map(({ key, icon }, i) => (
              <Reveal as="li" key={key} delay={i * 60} className="flex items-center gap-4">
                <ClayIcon name={icon} size={56} />
                <div>
                  <h3 className="m-0 text-lg font-semibold text-navy lg:text-xl">
                    {t(`home.servicesPreview.${key}.title`)}
                  </h3>
                  <p className="mb-0 mt-0.5 text-base leading-snug text-slate-600">
                    {t(`home.servicesPreview.${key}.desc`)}
                  </p>
                </div>
              </Reveal>
            ))}
          </ul>
          <Link to="/services" className="btn-outline-navy mt-6">
            {t('home.servicesPreview.viewAll')}
          </Link>
        </div>
        <Gallery />
      </div>
    </section>
  );
}

export default WhereWeDrive;
